module.exports = __webpack_public_path__ + "assets/img/illegal.5115a85a.png";